"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var component_fields_1 = require("@doordash/component-fields");
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var CardFieldsStyles_1 = require("./CardFieldsStyles");
var StripeInput = function (_a) {
    var labelName = _a.labelName, error = _a.error, children = _a.children;
    return (React.createElement(design_language_1.Text, { tag: "label", styles: design_language_1.Text.Styles.Medium14 },
        React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.Label }, labelName),
        React.createElement(CardFieldsStyles_1.InputContainer, { error: error }, children),
        error && (React.createElement(CardFieldsStyles_1.FieldError, null,
            React.createElement(component_fields_1.ErrorMessage, { error: error })))));
};
exports["default"] = StripeInput;
